var map = {
	"./1.png": "PKR3",
	"./10.png": "BalY",
	"./11.png": "Hc8R",
	"./12.png": "etJO",
	"./13.png": "0SiP",
	"./14.png": "UIgi",
	"./15.png": "Cjhm",
	"./16.png": "FE4s",
	"./17.png": "DX4M",
	"./18.png": "drFX",
	"./19.png": "Cuq/",
	"./2.png": "wYHo",
	"./20.png": "tAyz",
	"./3.png": "rgrU",
	"./4.png": "bK8o",
	"./5.png": "inR2",
	"./6.png": "UON1",
	"./7.png": "CZhX",
	"./8.png": "Lsox",
	"./9.png": "/zuT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ls8h";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons ^\.\/.*\.png$
// module id = ls8h
// module chunks = 1